import React from 'react';
import PropTypes from 'prop-types';
import { formatRouteLabelInline, getRoutePrimaryLabel, getRouteSecondaryLabel } from '../../../utils/common/route-label';

const RouteLabel = ({ route, inline, className, prefix }) => {
    if (!route) {
        return null;
    }

    if (inline) {
        return <span className={ className }>{ formatRouteLabelInline(route) }</span>;
    }

    const secondary = getRouteSecondaryLabel(route);
    const primary = <span className="route-label__primary">{ getRoutePrimaryLabel(route) }</span>;

    return (
        <span className={ `route-label ${className || ''}` }>
            { prefix ? (
                <span>
                    { `${prefix} ` }
                    { primary }
                </span>
            ) : primary }
            { secondary && <span className="route-label__secondary">{ secondary }</span> }
        </span>
    );
};

RouteLabel.propTypes = {
    route: PropTypes.object,
    inline: PropTypes.bool,
    className: PropTypes.string,
    prefix: PropTypes.string,
};

RouteLabel.defaultProps = {
    route: null,
    inline: false,
    className: '',
    prefix: '',
};

export default RouteLabel;
